import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Router, Switch } from 'react-router-dom';
import { Route, Redirect } from 'react-router';
import createHistory from 'history/createBrowserHistory';
import ProcessTemplate from './components/ProcessTemplate';
import ProcessTemplate2 from './components/ProcessTemplate2';
import ProcessGroup from './components/ProcessGroup';
import ProcessType from './components/ProcessType';
import ProcessManagement from './components/ProcessManagement';
import CompanyContact from './components/CompanyContact';
import Department from './components/Department';
import Notification from './components/NotificationNew';
import UserNotification from './components/UserNotification';
import Authorization from './components/Authorization';
import NewProcess from './components/NewProcess';
import NewProcessFromTemplate from './components/NewProcessFromTemplate';
import Login from './components/Login';
import RedirectAdress from './components/Login/redirect';
import CheckOver from './components/Login/checkover';
import NotFound from './components/NotFound';
import AuthenticatedRoute from './components/Routing/AuthenticatedRoute';
import UnAuthenticatedRoute from './components/Routing/UnAuthenticatedRoute';
import NotificationBar from './components/NotificationBar';
import { store } from './index';
import { initialize } from './redux/actions';
import SideMenu2 from "./components/SideMenu2";
import ProcessReport from './components/ProcessReport';

export const history = createHistory();

class App extends Component {
  componentDidMount() {
    store.dispatch(initialize());
  }
  render() {
    return (
      <Router history={history}>
        <div>
          <SideMenu2/>
          <Switch>
            <UnAuthenticatedRoute exact path="/" component={Login} />
            <AuthenticatedRoute path="/processtemplate" component={ProcessTemplate} />
            <AuthenticatedRoute path="/processtemplate2" component={ProcessTemplate2} />
            <AuthenticatedRoute path="/processgroup" component={ProcessGroup} />            
            <AuthenticatedRoute path="/processtype" component={ProcessType} />
            <AuthenticatedRoute path="/processmanagement" component={ProcessManagement} />
            <AuthenticatedRoute path="/companycontact" component={CompanyContact} />
            <AuthenticatedRoute path="/department" component={Department} />
            <AuthenticatedRoute path="/notification" component={Notification} /> 
            <AuthenticatedRoute path="/usernotification" component={UserNotification} /> 
            <AuthenticatedRoute path="/authorization" component={Authorization} />                        
            <AuthenticatedRoute path="/newprocess" component={NewProcess} />
            <AuthenticatedRoute path="/newprocessfromtemplate" component={NewProcessFromTemplate} />
            <AuthenticatedRoute path="/processreport" component={ProcessReport} />
            <UnAuthenticatedRoute path="/login" component={Login} />
            <Route path="/redirect" component={RedirectAdress} />  
            <Route path="/checkover" component={CheckOver} />     
            <Redirect from='/home' to='/' />
            <Route component={NotFound} />
          </Switch>
          <NotificationBar/>
        </div>
      </Router>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => dispatch(action)
});

export default connect(null, mapDispatchToProps)(App);
